// @ts-strict-ignore
import { useMemo } from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import i18n from 'src/utils/translate';
import { stripBBTags } from 'src/utils/string';
import { clickEventsReply } from 'src/modules/shared/resultsListNew/footfallEvents';
import { MetaWrapper, AvatarLink, MetaTextWrapper, ReplyBody } from 'styles-js/postItem';
import Avatar, { Size } from 'src/components/avatar';
import RelativeTime from 'src/components/relativeTime';
import PostLink from 'src/modules/shared/links/postLink';
import { PostType } from 'src/constants/types';
type IsEvent = {
  isOnAvatarClick?: boolean;
  isOnCommunityClick?: boolean;
  isOnBodyClick?: boolean;
  isOnMetaTextClick?: boolean;
};
type ReplyProps = {
  author: {
    username: string;
    userImageHash: string;
  };
  bodySnippet: string;
  community: {
    name: string;
    slug: string;
  };
  clickMetadata?: {
    section: string;
    element?: string;
    origin?: string;
  };
  dateCreated?: string;
  isFootfallEvents?: IsEvent;
  isPrivate: boolean;
  postId: number;
  postTypeId: PostType;
  replyAsPost?: boolean;
  responseId: number;
  urlEncodedTitle: string;
};
export default function ReplyItem({
  author,
  bodySnippet,
  clickMetadata,
  community,
  dateCreated,
  isFootfallEvents,
  isPrivate,
  postId,
  postTypeId,
  replyAsPost = false,
  responseId,
  urlEncodedTitle
}: ReplyProps) {
  const cleanReplySnippet = useMemo(() => bodySnippet && stripBBTags(bodySnippet), [bodySnippet]);
  const clickEvents = clickEventsReply({
    replyAsPost,
    clickMetadata,
    ...isFootfallEvents
  });
  return <>
      <ReplyContainer data-sentry-element="ReplyContainer" data-sentry-source-file="replyItem.tsx">
        <MetaWrapper data-sentry-element="MetaWrapper" data-sentry-source-file="replyItem.tsx">
          <Link legacyBehavior passHref as={`/user/${author?.username}`} href={`/user/profile?username=${author?.username}`} data-sentry-element="Link" data-sentry-source-file="replyItem.tsx">
            <AvatarLink onClick={clickEvents?.onAvatarClick} data-sentry-element="AvatarLink" data-sentry-source-file="replyItem.tsx">
              <Avatar hash={author?.userImageHash} name={author?.username} size={Size.Small} data-sentry-element="Avatar" data-sentry-source-file="replyItem.tsx" />
            </AvatarLink>
          </Link>
          <MetaTextWrapper data-sentry-element="MetaTextWrapper" data-sentry-source-file="replyItem.tsx">
            <PostLink communitySlug={community.slug} isPrivate={isPrivate} postId={postId} postTypeId={postTypeId} responseId={responseId} urlEncodedTitle={urlEncodedTitle} onClick={clickEvents?.isOnMetaTextClick} data-sentry-element="PostLink" data-sentry-source-file="replyItem.tsx">
              {replyAsPost ? <>
                  {author.username}
                  {i18n.t(' replied ')}
                </> : <>
                  {i18n.t('Latest reply by ')}
                  {author.username}{' '}
                </>}
              {dateCreated && <RelativeTime rawTime={dateCreated} />}
            </PostLink>
          </MetaTextWrapper>
        </MetaWrapper>

        <PostLink communitySlug={community.slug} isPrivate={isPrivate} postId={postId} postTypeId={postTypeId} responseId={responseId} urlEncodedTitle={urlEncodedTitle} onClick={clickEvents?.onBodyClick} data-sentry-element="PostLink" data-sentry-source-file="replyItem.tsx">
          <ReplyBody data-sentry-element="ReplyBody" data-sentry-source-file="replyItem.tsx">{cleanReplySnippet}</ReplyBody>
        </PostLink>

      </ReplyContainer>
    </>;
}
const ReplyContainer = styled.div`
  margin-top: 10px;
  border-radius: 3px;
  padding: 10px;
  background-color: ${({
  theme
}) => theme.colorBlueBackground};
  a {
    color: ${({
  theme
}) => theme.colorTextBlack};
  }
`;